import React from 'react';
import {
  Box,
  Container,
  Typography,
  Paper,
  List,
  ListItem,
  ListItemText,
  Button,
  Divider,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const PrivacyPolicyPage: React.FC = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    // 履歴があるかチェックして、なければチャットページに戻る
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate('/chat');
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        py: { xs: 2, sm: 4, md: 6 },
      }}
    >
      <Container maxWidth="md">
        {/* Header */}
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
          <Button
            startIcon={<ArrowBackIcon />}
            onClick={handleBack}
            sx={{
              color: 'white',
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
              },
            }}
          >
            戻る
          </Button>
        </Box>

        <Paper
          elevation={8}
          sx={{
            p: { xs: 3, sm: 4, md: 6 },
            borderRadius: 3,
            background: 'rgba(255, 255, 255, 0.95)',
            backdropFilter: 'blur(20px)',
          }}
        >
          {/* Title */}
          <Typography
            variant="h4"
            component="h1"
            gutterBottom
            sx={{
              fontWeight: 'bold',
              textAlign: 'center',
              mb: 4,
              background: 'linear-gradient(45deg, #667eea, #764ba2)',
              backgroundClip: 'text',
              WebkitBackgroundClip: 'text',
              color: 'transparent',
            }}
          >
            個人情報保護方針
          </Typography>

          {/* Company Information */}
          <Box sx={{ mb: 4, textAlign: 'center' }}>
            <Typography variant="h6" sx={{ mb: 1 }}>
              会社名：株式会社Gerbera
            </Typography>
            <Typography variant="body1" color="text.secondary">
              代表取締役：𠮷岡 歩真
            </Typography>
          </Box>

          <Divider sx={{ mb: 4 }} />

          {/* Introduction */}
          <Typography variant="body1" sx={{ mb: 4, lineHeight: 1.8 }}>
            当社は、個人情報保護に関する法令を遵守し、その取扱い及び保護等について、個人情報保護法に基づき、事業を行なうことを宣言いたします。
          </Typography>

          {/* Privacy Policy Items */}
          <List sx={{ mb: 4 }}>
            <ListItem sx={{ alignItems: 'flex-start', px: 0 }}>
              <ListItemText
                primary={
                  <Typography variant="h6" component="div" sx={{ mb: 1, fontWeight: 'bold' }}>
                    1. 個人情報の収集・利用・提供について
                  </Typography>
                }
                secondary={
                  <Typography variant="body1" sx={{ lineHeight: 1.7 }}>
                    個人情報を保護・管理する体制を確立し、適切な収集・利用・提供に関する規程を定め遵守いたします。
                  </Typography>
                }
              />
            </ListItem>

            <ListItem sx={{ alignItems: 'flex-start', px: 0 }}>
              <ListItemText
                primary={
                  <Typography variant="h6" component="div" sx={{ mb: 1, fontWeight: 'bold' }}>
                    2. 個人情報の安全対策
                  </Typography>
                }
                secondary={
                  <Typography variant="body1" sx={{ lineHeight: 1.7 }}>
                    個人情報に対するリスク（個人情報への不正アクセス、個人情報の紛失、破壊、改ざん）に対して、合理的な対策をとり、個人情報の安全性・正確性を確保いたします。
                  </Typography>
                }
              />
            </ListItem>

            <ListItem sx={{ alignItems: 'flex-start', px: 0 }}>
              <ListItemText
                primary={
                  <Typography variant="h6" component="div" sx={{ mb: 1, fontWeight: 'bold' }}>
                    3. 個人情報に関する法令・規範の遵守
                  </Typography>
                }
                secondary={
                  <Typography variant="body1" sx={{ lineHeight: 1.7 }}>
                    個人情報に関する法令・規範を常に意識し、その内容を遵守いたします。
                  </Typography>
                }
              />
            </ListItem>

            <ListItem sx={{ alignItems: 'flex-start', px: 0 }}>
              <ListItemText
                primary={
                  <Typography variant="h6" component="div" sx={{ mb: 1, fontWeight: 'bold' }}>
                    4. 個人情報保護への取り組みの継続的改善について
                  </Typography>
                }
                secondary={
                  <Typography variant="body1" sx={{ lineHeight: 1.7 }}>
                    個人情報の保護を適切に行うため、常にその取り組みの改善・向上に努めます。
                  </Typography>
                }
              />
            </ListItem>

            <ListItem sx={{ alignItems: 'flex-start', px: 0 }}>
              <ListItemText
                primary={
                  <Typography variant="h6" component="div" sx={{ mb: 1, fontWeight: 'bold' }}>
                    5. 個人情報保護に関する連絡先
                  </Typography>
                }
                secondary={
                  <Box sx={{ mt: 1 }}>
                    <Typography variant="body1" sx={{ mb: 1 }}>
                      電話番号：06-7176-5480
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1 }}>
                      FAX番号：06-7635-8254
                    </Typography>
                    <Typography variant="body1">
                      E-mail：info@gakufudo-career.jp
                    </Typography>
                  </Box>
                }
              />
            </ListItem>
          </List>

          <Divider sx={{ mb: 3 }} />

          {/* Footer */}
          <Box sx={{ textAlign: 'right' }}>
            <Typography variant="body2" color="text.secondary">
              以上
            </Typography>
          </Box>
        </Paper>

        {/* Bottom Footer */}
        <Box sx={{ textAlign: 'center', mt: 4 }}>
          <Typography 
            variant="body2" 
            color="white" 
            sx={{ opacity: 0.8 }}
          >
            © {new Date().getFullYear()} 株式会社Gerbera. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default PrivacyPolicyPage; 